import { config } from 'config';
import { restClient } from 'modules/shared/services/API/backend';
import { Brand, GetBrand } from '../../models';

export const brandService = {
    get: async ({ id }: GetBrand) => {
        const response = await restClient.get<Brand>(`${config.backend.rest.catalogueUrl}/brand/${id}`);
        return response.data;
    },
    getAll: async () => {
        const response = await restClient.get<Brand[]>(`${config.backend.rest.catalogueUrl}/brand/`);
        return response.data;
    },
};
